import React from "react";
import { Star, Search } from "lucide-react";

const NAVY = "#1B1F5C";

const Check = ({ checked, onChange, label }) => (
  <label className="flex items-center gap-2.5 py-1 cursor-pointer group">
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="h-[15px] w-[15px] rounded border-gray-300 accent-[#1B1F5C] cursor-pointer"
    />
    <span className="text-[12.5px] font-semibold text-gray-600 group-hover:text-[#1B1F5C] transition-colors">{label}</span>
  </label>
);

const SectionHead = ({ children }) => (
  <p className="text-[13px] font-extrabold mb-2 mt-5" style={{ color: NAVY }}>{children}</p>
);

const FilterSidebar = ({ config, filters, setFilters, selectedCategory, setSelectedCategory }) => {
  const toggle = (key, value) => {
    setFilters((prev) => {
      const arr = prev[key] || [];
      return { ...prev, [key]: arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value] };
    });
  };

  const clearAll = () => {
    setFilters({ ages: [], prices: [], brands: [], rating: null, genders: [], occasions: [], min: "", max: "" });
    setSelectedCategory("All Categories");
  };

  return (
    <aside className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 h-fit text-left">
      {/* Categories */}
      <p className="font-display font-extrabold text-[16px] mb-3" style={{ color: NAVY }}>Categories</p>
      <ul className="space-y-0.5">
        {config.categories.map((c) => (
          <li key={c}>
            <button
              onClick={() => setSelectedCategory(c)}
              className={`text-[12.5px] font-bold py-1 transition-colors ${selectedCategory === c ? "text-[#35C3C1]" : "text-gray-600 hover:text-[#1B1F5C]"}`}
            >
              {c}
            </button>
          </li>
        ))}
      </ul>

      <div className="border-t border-gray-100 mt-4" />
      <p className="font-display font-extrabold text-[16px] mt-4" style={{ color: NAVY }}>Filter By</p>

      {/* Age Range */}
      <SectionHead>Age Range</SectionHead>
      {config.ages.map((a) => (
        <Check key={a} label={a} checked={(filters.ages || []).includes(a)} onChange={() => toggle("ages", a)} />
      ))}

      {/* Gender (gifts) */}
      {config.genders && (
        <>
          <SectionHead>Gender</SectionHead>
          {config.genders.map((g) => (
            <Check key={g} label={g} checked={(filters.genders || []).includes(g)} onChange={() => toggle("genders", g)} />
          ))}
        </>
      )}

      {/* Occasion (gifts) */}
      {config.occasions && (
        <>
          <SectionHead>Occasion</SectionHead>
          {config.occasions.map((o) => (
            <Check key={o} label={o} checked={(filters.occasions || []).includes(o)} onChange={() => toggle("occasions", o)} />
          ))}
        </>
      )}

      {/* Brand */}
      {config.brands && (
        <>
          <SectionHead>Brand</SectionHead>
          {config.brandSearch && (
            <div className="relative mb-2">
              <input
                type="text"
                placeholder="Search Brand"
                value={filters.brandSearch || ""}
                onChange={(e) => setFilters((prev) => ({ ...prev, brandSearch: e.target.value }))}
                className="w-full h-8 pl-8 pr-2.5 rounded-md border border-gray-200 text-[12px] font-semibold outline-none focus:border-[#35C3C1]"
              />
              <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
            </div>
          )}
          {config.brands
            .filter((b) => !filters.brandSearch || b.toLowerCase().includes(filters.brandSearch.toLowerCase()))
            .map((b) => (
              <Check key={b} label={b} checked={(filters.brands || []).includes(b)} onChange={() => toggle("brands", b)} />
            ))}
          <button className="text-[12px] font-extrabold mt-1.5 hover:underline" style={{ color: NAVY }}>View More</button>
        </>
      )}

      {/* Customer Rating */}
      {config.showRating && (
        <>
          <SectionHead>Customer Rating</SectionHead>
          {[4, 3, 2].concat([]).map(() => null)}
          {[5, 4, 3, 2].map((r) => (
            <label key={r} className="flex items-center gap-2.5 py-1 cursor-pointer">
              <input
                type="checkbox"
                checked={filters.rating === r}
                onChange={() => setFilters((prev) => ({ ...prev, rating: prev.rating === r ? null : r }))}
                className="h-[15px] w-[15px] accent-[#1B1F5C] cursor-pointer"
              />
              <span className="flex items-center gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} size={12} className={i <= r ? "text-[#F79433] fill-[#F79433]" : "text-gray-300 fill-gray-300"} />
                ))}
              </span>
              <span className="text-[12px] font-semibold text-gray-500">& Up</span>
            </label>
          ))}
        </>
      )}

      {/* Clear All */}
      <button
        onClick={clearAll}
        className="mt-6 w-full h-9 rounded-full border-2 border-[#35C3C1] text-[11.5px] font-extrabold tracking-widest text-[#1B1F5C] hover:bg-[#35C3C1] hover:text-white transition-colors"
      >
        CLEAR ALL
      </button>
    </aside>
  );
};

export default FilterSidebar;
